import EntranceSlide from "./EntranceSlide";
import TitleSlide from "./TitleSlide";
import HeaderTitleSlide from "./HeaderTitleSlide";
import HeaderTitleSlide1 from "./HeaderTitleSlide1";
import HeaderTitleSlide2 from "./HeaderTitleSlide2";
import HeaderTitleSlide3 from "./HeaderTitleSlide3";
import HeaderTitleSlide4 from "./HeaderTitleSlide4";
import IntroStatementSlide from "./IntroStatementSlide";
import IntroStatementSlide1 from "./IntroStatementSlide1";
import IntroStatementSlide2 from "./IntroStatementSlide2";
import IntroStatementSlide3 from "./IntroStatementSlide3";
import IntroStatementSlide4 from "./IntroStatementSlide4";
import LearningObjectivesSlide from "./LearningObjectivesSlide";
import LearningObjectivesSlide1 from "./LearningObjectivesSlide1";
import LearningObjectivesSlide4 from "./LearningObjectivesSlide4";
import entrance1 from "./entrance1";
import entrance2 from "./entrance2";
import entrance3 from "./entrance3";
import entrance4 from "./entrance4";

// Ensure schema IDs match config IDs
const schemas = [
  { ...EntranceSlide, id: "entrance-slide" },
  { ...TitleSlide, id: "title-slide" },
  { ...HeaderTitleSlide, id: "header-title-slide" },
  { ...HeaderTitleSlide1, id: "header-title1-slide" },
  { ...HeaderTitleSlide2, id: "header-title2-slide" },
  { ...HeaderTitleSlide3, id: "header-title3-slide" },
  { ...HeaderTitleSlide4, id: "header-title4-slide" },
  { ...IntroStatementSlide, id: "intro-statement-slide" },
  { ...IntroStatementSlide1, id: "intro-statement1-slide" },
  { ...IntroStatementSlide2, id: "intro-statement2-slide" },
  { ...IntroStatementSlide3, id: "intro-statement3-slide" },
  { ...IntroStatementSlide4, id: "intro-statement4-slide" },
  { ...LearningObjectivesSlide, id: "learning-objectives-slide" },
  { ...LearningObjectivesSlide1, id: "learning-objectives1-slide" },
  { ...LearningObjectivesSlide4, id: "learning-objectives4-slide" },
  { ...entrance1, id: "entrance1-slide" },
  { ...entrance2, id: "entrance2-slide" },
  { ...entrance3, id: "entrance3-slide" },
  { ...entrance4, id: "entrance4-slide" },
];

export default schemas;
